export default __webpack_public_path__ + "static/media/conduiitWhite.b2d6192f.svg";